<template>
  <section class="scrollable padder">
    <div v-if="loading" class="loading">Loading&#8230;</div>
    <div v-if="showAlert" class="alert alert-danger alert-dismissible">
      <button
        type="button"
        class="close"
        aria-hidden="true"
        @click="closeAlert"
      >
        ×
      </button>
      <h4><i class="icon fa fa-ban"></i> Error!</h4>
      {{ errMessage }}
    </div>
    <section class="panel panel-default">
     
      <div class="modal-body">
        <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(addEditUOM)" method="post">
            
          <div class="col-sm-12">
             <ValidationProvider
               name="Unit Of Measure"
                  rules="required|alpha"
                  v-slot="{ errors }"
               >
            <div class="form-group">
              <label for="category">
                Unit Of Measure <span class="required-color">*</span></label
              >
              <input
                type="text"
                id="uom"
                class="form-control"
                v-model="uomName"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid UOM"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Unit Of Measure"
              />
               <span style="color:red">{{ errors[0] }}</span>
            </div>
          
                </ValidationProvider>
          </div>

          <div class="modal-footer" style="text-align: right">
           
            <button
              :disabled="saveCat"
              id="btn_save"
              type="submit"
              class="btn btn-success  text-center  "
            >
              Save
            </button>
             <a
              v-on:click="$emit('hide-uom')"
              class="btn btn-danger  text-center  "
            >
              Close
            </a>
          </div>
        </form>
        </ValidationObserver>
      </div>
      
    </section>
  </section>
</template>

<script>
import api from "../api";

export default {
  props: ["uomId"],
  name: "AddUOM",
  data() {
    return {
      saveCat: false,
      parent_id: "0",
      uom_id: '',
      uomList: [],
      errors : [],
      uomName: "",
      baseUrl: this.$store.state.baseURL,
      showCatDropdown: false,
      loading: false,
    };
  },
  components: {},
  methods: {
    addEditUOM() {
       this.loading = false
      this.saveCat = true;
      this.uom_id = this.$props.uomId;
      this.errors = []
      if (!this.uomName) {
        this.errors.push("Unit Of Measure required.");
      }
      if(!this.errors.length){
      const addUOM = {
        "uom-form": {
          uom_id: this.uom_id,
          uom_name: this.uomName
          /*,
          sort_order: this.sort_order,
          color_code: this.color_code,
          category_image: this.category_image,*/
        },
      };
      if (this.uom_id > 0) {
        api
          .request("post", "GeneralApis/edit_uom", addUOM)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              alert("Succesfully Updated");
              this.$emit("hide-uom");
              this.$emit("list-uom");
            }
          });
      } else {
        api
          .request("post", "GeneralApis/add_uom", addUOM)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              alert("Succesfully Added");
              this.$emit("hide-uom");
              this.$emit("list-uom");
            }
          });
      }
      }
    },
    getUOM: function() {
      var uomid = this.$props.uomId;
      (this.uomList = []),
        (this.uomName = ""),/*
        (this.sort_order = ""),
        (this.color_code = ""),
        (this.fileContent = ""),*/
        (this.uom_id = 0);
      if (uomid > 0) {
        this.uom_id = uomid;

        const getlist = {
          filter: {
            uom_id: this.uom_id,
          },
        };
        api
          .request("post", "GeneralApis/get_uom", getlist)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              this.uomList = data.uomList[0];
              this.uomName = this.uomList.uom_name;/*
              this.sort_order = this.catlist.sort_order;
              this.color_code = this.catlist.color_code;
              this.fileContent = this.baseUrl + this.catlist.category_image;*/
            }
          });
      }
    },
  },
  mounted() {
    this.getUOM();
  },
};
</script>
